import React, { useState } from "react";
import { Modal, Button } from "antd";
import { useNavigate } from "react-router-dom";
import AppInput from "./AppInput";
import { post } from "../services/services";
import { ApiURL } from "../services/apiConstants";
import { ErrorToast, SuccessToast } from "../widgets/AppToast";

const ForgateCodeModal = ({ isCodeModalOpen, setCodeIsModalOpen }) => {
  const navigate = useNavigate();
  const [newCode, setNewCode] = useState("");
  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);
  const [oldCode, setOldCode] = useState("");

  const handleSave = async () => {
    const newErrors = {};
    if (!newCode) newErrors.newCode = "New code is required";
    setErrors(newErrors);

    if (Object.keys(newErrors).length === 0) {
      setLoading(true);
      try {
        const FORM_DATA = new FormData();
        FORM_DATA.append("new_code", newCode);
        FORM_DATA.append("old_code", oldCode);
        const res = await post(ApiURL.update_staff_security_code_st, FORM_DATA);
        if (res?.status === true) {
          SuccessToast(
            "Staff Code Updated",
            "Security code successfully updated!"
          );
          setCodeIsModalOpen(false);
          setNewCode("");
          setOldCode("");
        } else {
          ErrorToast(
            "Failed to Update",
            res?.message || "Something went wrong"
          );
        }
      } catch (error) {
        console.error("Error updating code:", error);
        ErrorToast("Error", "An error occurred while updating code.");
      } finally {
        setLoading(false);
      }
    }
  };

  return (
    <Modal
      title="Update Security Code"
      open={isCodeModalOpen}
      onCancel={() => {
        setCodeIsModalOpen(false);
        setNewCode("");
        setOldCode("");
      }}
      footer={null}
      style={{
        position: "fixed",
        top: "60px",
        right: "270px",
        borderRadius: "8px",
        zIndex: 9999,
      }}
    >
      <div className="row">
        <div className="col-12">
          <AppInput
            maxLength={6}
            label="Old Code"
            placeholder="Enter old code"
            value={oldCode}
            onChange={(e) => setOldCode(e.target.value)}
            errors={errors.oldCode}
          />
        </div>
      </div>

      <div className="row">
        <div className="col-12">
          <AppInput
            maxLength={6}
            label="New Code"
            placeholder="Enter new code"
            value={newCode}
            onChange={(e) => setNewCode(e.target.value)}
            errors={errors.newCode}
          />
        </div>
      </div>

      <div className="row">
        <div className="col-12" style={{ marginTop: 16, textAlign: "right" }}>
          <Button type="primary" loading={loading} onClick={handleSave}>
            Save
          </Button>
        </div>
      </div>
    </Modal>
  );
};

export default ForgateCodeModal;
